export default function TrustSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-serif text-3xl md:text-4xl text-foreground-900">
            ( What Our Users Say )
          </h2>
        </div>

        <div className="max-w-2xl mx-auto relative">
          <div className="flex items-start gap-4 mb-4">
            <span className="inline-flex items-center gap-1 bg-foreground-900 text-white text-xs font-medium px-3 py-1.5 rounded-full whitespace-nowrap">
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-star-fill text-accent-400 text-xs"></i>
              </span>
              4.9
            </span>
          </div>

          <div className="relative pl-6 md:pl-8">
            <span className="absolute left-0 top-0 font-serif text-5xl md:text-6xl text-foreground-200 leading-none select-none">
              &ldquo;
            </span>
            <p className="font-serif text-lg md:text-xl text-foreground-700 leading-relaxed italic pt-2">
              The Kakobuy Spreadsheet completely changed how I discover products. Instead of spending hours
              browsing random listings, I can quickly scan organized categories and find exactly what I want.
              The community recommendations are incredibly accurate, and the regular updates mean I am always
              the first to know about trending items. It is hands down the best shopping resource I have
              ever used.
            </p>
          </div>

          <div className="flex items-center gap-3 mt-6 pl-6 md:pl-8">
            <div className="w-10 h-10 rounded-full bg-background-200 overflow-hidden flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20stylish%20young%20person%20on%20urban%20rooftop%20at%20golden%20hour%20warm%20sunset%20lighting%20city%20skyline%20in%20soft%20blur%20background%20confident%20expression%20clean%20modern%20aesthetic&width=80&height=80&seq=testimonial-avatar-v2&orientation=squarish"
                alt="User testimonial"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div>
              <div className="font-medium text-foreground-900 text-sm">Sarah Mitchell</div>
              <div className="text-xs text-foreground-500">Verified Kakobuy Spreadsheet User</div>
            </div>
          </div>

          <div className="flex justify-end gap-2 mt-8">
            <button className="w-10 h-10 flex items-center justify-center rounded-lg border border-foreground-200 text-foreground-500 hover:border-foreground-400 hover:text-foreground-700 transition-colors cursor-pointer" aria-label="Previous">
              <i className="ri-arrow-left-line"></i>
            </button>
            <button className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-900 text-white hover:bg-foreground-800 transition-colors cursor-pointer" aria-label="Next">
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}